import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";

import * as serviceWorker from "./serviceWorker";
import { Auth0Provider } from "@auth0/auth0-react";
import App from "./App";
const providerConfig = {
  domain: "dev-etuaxjwxlqsmj55r.us.auth0.com",
  clientId: "FqzrhICWaCSHcNCvx6IwZBoLv1HPM3B8"
};

const root = createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    {...providerConfig}
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
    >
    <App />
  </Auth0Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
